import { useContext, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import type { AIToolComponent } from '../../chat-messages/GuardianMarkdown';
import { GuardianContext } from '../../GuardianProvider';

export type FollowUpQuestion = {
  id: string;
  title: string;
  prompt?: string;
  url?: string;
};

export const FollowUpQuestions: AIToolComponent<FollowUpQuestion[]> = ({
  params: followUpQuestions,
  isLastResponse,
}) => {
  const { setFollowUpQuestions } = useContext(GuardianContext);

  useEffect(() => {
    if (isLastResponse) {
      const followUpQuestionsWithId = followUpQuestions.map((question) => ({ ...question, id: uuidv4() }));
      setFollowUpQuestions(followUpQuestionsWithId);
      return () => setFollowUpQuestions([]);
    }
  }, [isLastResponse, followUpQuestions.map, setFollowUpQuestions]);

  return false;
};

FollowUpQuestions.description = 'Displays a followUpQuestions with a title and prompt.';

FollowUpQuestions.schema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    properties: {
      title: { type: 'string' },
      prompt: { type: 'string' },
      url: { type: 'string' },
    },
    required: ['title'],
  },
};
